const ANALYTICS_QUEUE = []
let flushTimeout = null

function enqueue(event) {
  ANALYTICS_QUEUE.push(event)
  
  // Debounce flush — send after 2 seconds of inactivity
  // or when queue reaches 20 events
  if (flushTimeout) clearTimeout(flushTimeout)
  
  if (ANALYTICS_QUEUE.length >= 20) {
    flush()
  } else {
    flushTimeout = setTimeout(flush, 2000)
  }
}

async function flush() {
  if (ANALYTICS_QUEUE.length === 0) return
  
  const events = ANALYTICS_QUEUE.splice(0, ANALYTICS_QUEUE.length)
  
  try {
    await fetch('/api/analytics/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events }),
      // Use keepalive so events send even if page is closing
      keepalive: true,
    })
  } catch {
    // Analytics must never break the user experience
    // Drop the events silently if the endpoint fails
  }
}

// Flush before page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', flush)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })
}

export function track(eventName, properties = {}) {
  // Never track in development
  if (process.env.NODE_ENV === 'development') {
    console.debug('[Analytics]', eventName, properties)
    return
  }
  
  enqueue({
    event: eventName,
    properties: {
      ...properties,
      // Strip any sensitive fields
      password: undefined,
      token: undefined,
    },
    timestamp: new Date().toISOString(),
    // Session ID from sessionStorage for funnel analysis
    sessionId: typeof window !== 'undefined' 
      ? sessionStorage.getItem('ed_session_id') 
      : null,
    // Page context
    page: typeof window !== 'undefined' 
      ? window.location.pathname 
      : null,
  })
}

// Initialize session ID on first load
if (typeof window !== 'undefined') {
  if (!sessionStorage.getItem('ed_session_id')) {
    sessionStorage.setItem('ed_session_id', 
      `sess_${Date.now()}_${Math.random().toString(36).slice(2)}`)
  }
}
